import { combineReducers } from 'redux';

import {
	verifyIMEIReducer,
	brandSearchReducer,
	exchangeTermsInfo,
	exchangeTooltipReducer,
	updateExchangeAnswer
} from './productExchangeReducer';
import productABBData from './productABBReducer';
import productDetails from './productDetailsReducer';
import {
	productSimilarRecoReducer as productSimilarReco,
	productCrossVerticalRecoReducer as productCrossVerticalReco,
	productBrowsingHistoryRecoReducer as productBrowsingHistoryReco
} from './productRecoReducer';
import productActions from './product-actions';
import productReservation from './productReservationReducer';
import productLayout from './productLayoutReducer';
import productImage from './productImageReducer';
import wiggleSwatches from './wiggleSwatches';
import recommendations from './recommendationReducer';
import productAttachs from './productAttachReducer';

let productPageReducer = {
	verifyImeiInfo: verifyIMEIReducer,
	brandSearchInfo: brandSearchReducer,
	exchangeTooltip: exchangeTooltipReducer,
	exchangeTermsInfo,
	productSimilarReco,
	productCrossVerticalReco,
	productBrowsingHistoryReco,
	productDetails,
	productActions,
	productReservation,
	productLayout,
	productImage,
	wiggleSwatches,
	productABBData,
	recommendations,
	updateExchangeAnswer,
	productAttachs
};

export default combineReducers(productPageReducer);
